import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Avatar, Space } from "antd";
import { StarFilled, UserOutlined } from "@ant-design/icons";
import { baseImageUrl } from "Common/Components/baseImageUrl";
const { Text, Paragraph } = Typography;
const WelcomeSection = ({ darkMode, mentor, learnerCount, performanceRating }) => {
  const fullStars = Math.floor(performanceRating);
  const hasHalfStar = performanceRating % 1 !== 0;
  const theme = {
    bg: darkMode ? "#1f1f1f" : "#fff",
    border: darkMode ? "#303030" : "#f0f0f0",
    text: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    secondaryText: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    avatarBorder: darkMode ? "#1890ff" : "#40a9ff"
  };
  return (
    <Card
      style={{
        borderRadius: 8,
        marginBottom: 12,
        backgroundColor: theme.bg,
        borderColor: theme.border,
        padding: '12px',
        display: 'flex',
        alignItems: 'center'
      }}
      bordered={false}
      bodyStyle={{ padding: 0, display: 'flex', width: '100%' }}
    >
      <div style={{ flex: 1, marginRight: 12 }}>
        <Text strong style={{
          color: theme.text,
          fontSize: '18px',
          display: 'block',
          marginBottom: 4
        }}>
          Welcome back, {mentor?.firstName}!
        </Text>
        <Paragraph style={{
          color: theme.secondaryText,
          marginBottom: 6,
          fontSize: '15px'
        }}>
          Mentoring <strong>{learnerCount}</strong> learners
        </Paragraph>
        <Space size={4} align="center">
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Rating: {performanceRating.toFixed(1)}/5
          </Text>
          {[...Array(fullStars)].map((_, i) => (
            <StarFilled key={`star-${i}`} style={{ color: 'gold', fontSize: '12px' }} />
          ))}
          {hasHalfStar && (
            <StarFilled style={{ color: 'gold', fontSize: '12px', opacity: 0.5 }} />
          )}
        </Space>
      </div>
      <Avatar
        size={64}
        src={mentor.profileImage ? `${baseImageUrl}${mentor.profileImage}` : null}
        icon={!mentor?.profileImage && <UserOutlined />}
        style={{
          border: `2px solid ${theme.avatarBorder}`,
          alignSelf: 'center'
        }}
      />
    </Card>
  );
};
WelcomeSection.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  mentor: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  performanceRating: PropTypes.number.isRequired,
  learnerCount: PropTypes.number.isRequired,
};
export default WelcomeSection;
